import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as userActions from 'actions/userActions';

export class Vehicle extends React.Component {

    constructor() {
        super();

        this.setVehicleNumber = this
            .setVehicleNumber
            .bind(this);
        this.saveVehicleNumber = this
            .saveVehicleNumber
            .bind(this);
    }

    setVehicleNumber(e) {
        const {userActions} = this.props;
        userActions.setVehicleNumber(e.target.value);
    }

    saveVehicleNumber(e) {
        e.preventDefault();
        const {user, userActions} = this.props;
        userActions.saveVehicleNumber(user.get('vehicleNumber'));
    }
    render() {

        const {user} = this.props;

        const needToShowVehicleComponent = !user.get('vehicleNumber') || !user.getIn(['vehicleValidationResults', 'isValid']) || !user.get('vehicleSaved');

        if (!needToShowVehicleComponent) {
            return null;
        }

        let formGroupClass = 'form-group';

        const validationMessages = user
            .getIn(['vehicleValidationResults', 'errors'])
            .map((error, index) => {
                return ((
                    <li key={'error' + index} className="text-danger">
                        {error}
                    </li>
                ));
            });

        if (user.getIn(['vehicleValidationResults', 'errors']).count() > 0) {
            formGroupClass = 'form-group has-error';
        }

        return (
            <div>

                <div className={formGroupClass}>
                    <label>
                        Which 5-Digit WOW Vehicle Number are you using today?
                    </label>
                    <input
                        type="text"
                        className="form-control"
                        onChange={this.setVehicleNumber}
                        value={user.get('vehicleNumber')}/>
                </div>

                <ul className="wow-fst-validation-list">
                    {validationMessages}
                </ul>

                <button
                    disabled={!user.getIn(['vehicleValidationResults', 'isValid'])}
                    onClick={this.saveVehicleNumber}
                    className="btn btn-primary btn-lg">Save</button>

            </div>

        );
    }

}

Vehicle.propTypes = {
    userActions: PropTypes.object.isRequired,
    user: PropTypes.object.isRequired
};

function mapStateToProps(state) {
    return {
        user: state.get('user')
    };
}

function mapDispatchToProps(dispatch) {
    return {
        userActions: bindActionCreators(userActions, dispatch)

    };
}

export default connect(mapStateToProps, mapDispatchToProps)(Vehicle);



// WEBPACK FOOTER //
// ./src/containers/Vehicle.js